import type { Page } from '@/payload-types';

export const fetchPages = async (deployId: string, tenantId: string, locale: string): Promise<Page[]> => {
  const res = await fetch(
    `/api/pages?where[deploy][equals]=${deployId}&where[tenant][equals]=${tenantId}&limit=200&depth=0&locale=${locale}`,
  );
  const { docs = [] } = await res.json();
  return docs as Page[];
};
